import React from 'react';
import ModalImage from "react-modal-image";
import Heart from "./heart.js"
import Display from "./display.js"
import Slack from "./slack.js"

const Communications = () => {
  return(
    <article id="communications">
      <h1 className="space-left bold">Communications & Displays</h1>
      <section>
        <h2>Adafruit IO Dashboard</h2>
        <article>
          <figure>
            <ModalImage
              small="./img/communications/adafruit.png"
              large="./img/communications/adafruit.png"
              hideZoom={true}
              hideDownload={true}
              showRotate={false}
              alt="Screeshot of a Adafruit IO dashboard that displays: the heart rate, respiratory rate, and ambient temperature, light, and humidity"
            />
            <figcaption>
              Adafruit IO Dashboard Capture
              <br />
              <a href="https://io.adafruit.com/" target="_blank" rel="noreferrer">Adafruit IO</a>
            </figcaption>
          </figure>
          <p>
            Above is a screenshot of our Adafruit IO Dashboard that displays health data recorded.
            It hosts 5 gauges that display the heart rate and respiratory rate, and ambient
            temperature, light level, and humidity. Finally, the dashboard also hosts a line chart
            to demonstrate the trend of movement. The dashboard also keeps histories of data
            collected. Below is a capture of heartrate data, stored on Adafruit IO, collected by
            one of our team members, Parker.
          </p>
          <Heart />
        </article>
      </section>
      <section id="display">
        <h2>Local OLED Display</h2>
        <Display />
      </section>
      <section id="slack">
        <h2>Slack Warnings</h2>
        <Slack />
      </section>
      <p className="align-center">
        <strong>*We only tested the prototype on ourselves. No babies are involved in testing this prototype.</strong>
      </p>
      <p className="align-center">
        Please see
        <a href="./data/CSE475Report.pdf" target="_blank" rel="noreferrer"> report </a>
        for more details on implementation.
      </p>
      <p id="to-top">
        <a href="#communications"> Back to Top </a>
      </p>
    </article>
  );
}

export default Communications;
